import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import lottie from 'lottie-web/build/player/lottie_light'

import { HolidayBackdrop } from 'components/HolidayBackdrop'

import { useCohortToUse } from 'hooks/useCohortToUse'

import { useDefaultSubscription } from 'modules/purchase/hooks'
import { useGetSubscriptionsList } from 'modules/purchase/hooks/useGetSubscriptionsList'

import { eventLogger } from 'services/eventLogger.service'

import giftAnimation from 'assets/animation/christmasGiftAnimation.json'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'
import { Cohort } from 'root-constants'

import { StyledHolidayGift as S } from './HolidayGift.styles'

const ANIMATION_NAME = 'holiday_gift'
const QUESTION = 'Your Black Friday offer is ready!'

const INTRO_OFFER_COHORTS = [
  Cohort.LUVLY_INTRO_FAST,
  Cohort.LUVLY_INTRO4_SALE,
  Cohort.LUVLY_INTRO_SALE,
]

export const HolidayGift: React.FC = () => {
  const { t } = useTranslation()
  const { search } = useLocation()
  const animationContainerRef = useRef(null)
  const cohortToUse = useCohortToUse()

  useGetSubscriptionsList()
  useDefaultSubscription()

  const handleContinue = () => {
    eventLogger.logQuestion({
      question: QUESTION,
    })
    goTo({
      pathname: INTRO_OFFER_COHORTS.includes(cohortToUse)
        ? PageId.PURCHASE_INTRO_OFFER
        : PageId.PURCHASE_REFUND,
      search,
    })
  }

  useEffect(() => {
    if (animationContainerRef.current) {
      lottie.loadAnimation({
        name: ANIMATION_NAME,
        container: animationContainerRef.current,
        animationData: giftAnimation,
        loop: true,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      })
    }

    return () => lottie.destroy(ANIMATION_NAME)
  }, [])

  return (
    <S.Root>
      <S.Header />

      <S.Wrapper>
        <HolidayBackdrop />
        <S.GiftWrapper>
          <S.Gift ref={animationContainerRef} />
          <S.Title>{t('purchase7.christmasGift')}</S.Title>
        </S.GiftWrapper>
        <S.Footer>
          <S.Button onClick={handleContinue}>{t('actions.continue')}</S.Button>
        </S.Footer>
      </S.Wrapper>
    </S.Root>
  )
}
